/**
 * v-mayusculas — El campo se escribe en MAYÚSCULAS mientras se teclea (no solo
 * al guardar): lo que se ve, lo que cuenta el `counter` y lo que viaja en el
 * v-model es lo mismo que guarda el backend.
 *
 * Uso: <v-text-field v-mayusculas v-model="nombre" />
 *
 * Mismo recurso que v-trim: se escucha 'input' en FASE DE CAPTURA sobre el
 * elemento raíz del componente (div.v-input), así el handler corre ANTES del
 * onInput interno de VTextField, que lee e.target.value ya convertido. No hace
 * falta despachar otro evento.
 *
 * Se conserva la posición del cursor: corregir una letra en medio del texto no
 * lo manda al final. Durante una composición (acentos con tecla muerta, IME) no
 * se toca el valor: se convierte en el 'input' que cierra la composición.
 */
const HANDLER = "__vMayusculasHandler__";

function onInputCapture(event) {
  const target = event.target;
  if (!target || event.isComposing) return;

  const tag = target.tagName;
  if (tag !== "INPUT" && tag !== "TEXTAREA") return;
  if (target.readOnly || target.disabled) return;

  const value = target.value;
  if (typeof value !== "string") return;

  const upper = value.toUpperCase();
  if (upper === value) return;

  const { selectionStart, selectionEnd } = target;
  target.value = upper;
  // toUpperCase puede cambiar el largo (p. ej. "ß" -> "SS"): solo se restaura
  // el cursor si no cambió.
  if (upper.length === value.length && selectionStart !== null) {
    target.setSelectionRange(selectionStart, selectionEnd);
  }
}

export default {
  inserted(el) {
    if (el[HANDLER]) return; // idempotente
    el[HANDLER] = onInputCapture;
    el.addEventListener("input", onInputCapture, true); // true = captura
  },

  unbind(el) {
    if (!el[HANDLER]) return;
    el.removeEventListener("input", el[HANDLER], true);
    delete el[HANDLER];
  },
};
